import { MatchCardToVideoDurationService } from '@src/services/composition/MatchCardToVideoDurationService';
import { useStore } from '@src/stores-v2/StoreContext';
import { getAudioDurationFromUrl } from '@src/utility/audio';
import { useMemo } from 'react';

export function useMatchCardToVideoDurationService(): MatchCardToVideoDurationService {
  const { editorStore } = useStore();
  const editor = editorStore.editor;
  return useMemo(
    () =>
      new MatchCardToVideoDurationService({
        editor,
        getMediaDuration: getAudioDurationFromUrl,
      }),
    [editor],
  );
}
